import style from './style.css';

const BenefitsSection = () => {
  const images = [
    {
      img: 'https://iccdn.in/bic/icons/tick-icon.svg',
      text: 'Pre-Approved by your Bank/NBFC',
    },
    {
      img: 'https://iccdn.in/bic/icons/cart-icon.svg',
      text: 'Shop with just your mobile number.',
    },
    {
      img: 'https://iccdn.in/bic/icons/calender-icon.svg',
      text: 'Easy auto-repayments',
    },
    {
      img: 'https://iccdn.in/bic/icons/menu-icon.svg',
      text: 'Dashboard to track your purchase history',
    },
  ];

  return (
    <div className={style.benefitsContainer}>
      <div className={style.headerText}>About Your Cardless EMI</div>
      {images.map((image) => (
        <div className={style.benefitsDetails}>
          <img
            src={image.img}
            className={style.lenderIcon}
            alt='benefits-icon'
          />
          <div className={style.text}>{image.text}</div>
        </div>
      ))}
    </div>
  );
};

export default BenefitsSection;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEmiDetails/benefitsSection/index.js